import React from 'react';
import Grid from '@material-ui/core/Grid'
import {
    AutocompleteArrayInput,
    BooleanInput,
    LongTextInput,
    NumberInput,
    ReferenceArrayInput,
    required
} from 'react-admin';
import {QuestionTypeInput} from "./QuestionType";

const QuestionFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <QuestionTypeInput source="type" validate={required()}/>
        </Grid>
        <Grid item xs={12} sm={6}>
            <NumberInput defaultValue={1} source="displayIndex" validate={required()} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <BooleanInput source="required" {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
        </Grid>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="title"
                           validate={required()} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="description" {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ReferenceArrayInput
                label="resources.questions.fields.choiceIds"
                source="choiceIds"
                reference="choices" {...props} validate={required()}>
                <AutocompleteArrayInput optionText={"text"}/>
            </ReferenceArrayInput>
        </Grid>
    </React.Fragment>
)

export default QuestionFields
